export class BackupZeroEtlFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "allowedTables",
            "baseName": "allowedTables",
            "type": "Array<BackupZeroEtlTableFilter>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupZeroEtlFilters.attributeTypeMap;
    }
    constructor() {
    }
}
